import { getMonitorStatusColorHex, logger } from '@fe/core';
import { FeMapPlugin } from '@fe/maplibre-extensions';
import { GeoJSONSource, Map as MaplibreMap } from 'maplibre-gl';
import { AirportMonitorStatusDto } from '../airports/airport-dto';

const LAYER_ID = 'fe-airport-monitor-status';

export class AirportMonitorStatusLayer implements FeMapPlugin {
    private map: MaplibreMap | null = null;

    onAdd(map: MaplibreMap) {
        this.map = map;
        this.map.addSource(LAYER_ID, {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: []
            }
        });

        this.map.addLayer(
            {
                id: LAYER_ID,
                type: 'circle',
                source: LAYER_ID,
                paint: {
                    'circle-radius': [
                        'interpolate',
                        ['linear'],
                        ['zoom'],
                        3,
                        9, // At zoom 3, radius = 9
                        10,
                        18 // At zoom 10+, radius = 18
                    ],
                    'circle-color': [
                        'match',
                        ['get', 'monitorStatus'],
                        0,
                        getMonitorStatusColorHex(0), // null
                        1,
                        getMonitorStatusColorHex(1), // clear
                        2,
                        getMonitorStatusColorHex(2), // info
                        3,
                        getMonitorStatusColorHex(3), // watch
                        4,
                        getMonitorStatusColorHex(4), // warning
                        5,
                        getMonitorStatusColorHex(5), // critical
                        6,
                        getMonitorStatusColorHex(6), // emergency
                        'rgba(0, 0, 0, 0)' // default fallback
                    ]
                }
            },
            'fe-airport-monitor-status-slot'
        );
    }

    onRemove(map: MaplibreMap) {
        map.removeLayer(LAYER_ID);
        map.removeSource(LAYER_ID);
        this.map = null;
    }

    setVisible(value: boolean) {
        this.map?.setLayoutProperty(LAYER_ID, 'visibility', value ? 'visible' : 'none');
    }

    public setData(data: GeoJSON.FeatureCollection<GeoJSON.Geometry, AirportMonitorStatusDto>) {
        if (!this.map || !this.map.getSource(LAYER_ID) || !this.map.getLayer(LAYER_ID)) {
            return;
        }

        (<GeoJSONSource>this.map!.getSource(LAYER_ID)).setData(data);
        logger.debug('Airport monitor status data set');
    }
}
